/* eslint-disable no-unused-vars */
import { Container, useMediaQuery, Grid, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../actions';
import collections from '../../constants/FirestoreCollections';
import BillingV2 from './components/BillingV2';
const useStyles = () => {
  return makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    chart: {
      paddingBottom: 64,
    },
  }));
};
function Dashboard() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  // hooks
  const firestore = useFirestore();
  const organization = useSelector((state) => state.app.organization);
  const appDispatch = useDispatch();
  // states
  const [config, setConfig] = useState();
  // eslint-disable-next-line no-unused-vars
  const [times, setTimes] = useState([]);
  // methods

  const setChargingModal = (boolean) => {
    return appDispatch({
      type: actions.changeLoading,
      loading: { loading: boolean, priority: 1 },
    });
  };
  // effects

  const setArrayOfTimes = async () => {
    try {
      const res = await firestore
        .collection(collections.bills)
        .where('organizationId', '==', organization.id)
        .get();

      if (!res.empty) {
        const dates = res.docs.map((doc) => doc.data());
        const _date = moment();
        let _times = dates
          .sort((a, b) => {
            const dateA = moment(a.date);
            const dateB = moment(b.date);
            return dateA < dateB ? 1 : -1;
          })
          .slice(0, 10)
          .map((e) => e.date);

        if (
          organization &&
          organization.billingData &&
          organization.billingData.initial &&
          (organization.billingData.initial === 1 ||
            organization.billingData.initial > _date.get('date'))
        ) {
          _times = _times.filter((e) => e !== _date.clone().add(1, 'month').format('YYYY-MM'));
        }

        setTimes(_times);
      } else {
        setTimes([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setChargingModal(false);
    }
  };

  // effects
  useEffect(async () => {
    setChargingModal(true);
    if (organization?.id) await setArrayOfTimes();
  }, [organization]);

  useEffect(() => {
    firestore
      .collection(collections.configurations)
      .where('name', '==', 'billing')
      .get()
      .then((res) => {
        if (!res.empty) {
          setConfig(res.docs[0].data());
        }
      });
  }, [firestore]);
  return (
    <Container maxWidth="lg">
      <Box pb={4}>
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} sm={10}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg">
              <BillingV2 times={times} />
            </Container>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
const Props = {};
Dashboard.propTypes = Props;
export default Dashboard;
